import React, { useState, useEffect } from "react";
import '../../components/ThreeTab/ThreeTab/MyAddress.css';
import { MdLocalPhone } from "react-icons/md";
import { CiMobile3 } from "react-icons/ci";
import { getAddressList, updateAddress, verifyPincode } from "../../API/Api";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SidebarTab from '.././SidebarTab/SidebarTab';
const MyAddress = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone_work: "",
    phone_mobile: "",
    pin_code: "",
    country: "",
    address_line_1: "",
    address_line_2: "",
    city: "",
    state: "",
    save_as: "",
  });
  const [addressId, setAddressId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isPincodeLoading, setIsPincodeLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        setIsLoading(true);
        const response = await getAddressList();

        if (response.status && response.data) {
          const user = response.data;
          const initialData = {
            full_name: user.full_name || "",
            email: user.email || "",
            phone_work: user.phone_work || "",
            phone_mobile: user.phone_mobile || "",
            pin_code: user.pin_code || "",
            country: user.country || "INDIA",
            address_line_1: user.address_line_1 || "",
            address_line_2: user.address_line_2 || "",
            city: user.city || "",
            state: user.state || "",
            save_as: user.save_as || "",
          };

          setFormData(initialData);
          setAddressId(user.id || null);
        } else {
          console.warn("No address data found in API response.");
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setError("Failed to load address details");
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  const hasFormChanges = () => {
    return JSON.stringify(formData) !== JSON.stringify();
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handlePincodeChange = async (e) => {
    if (!isEditing) return;

    const { value } = e.target;
    setFormData({ ...formData, pin_code: value });

    if (value.length === 6) {
      try {
        setIsPincodeLoading(true);
        const response = await verifyPincode(value);

        if (response.status && response.data) {
          setFormData(prev => ({
            ...prev,
            city: response.data.city || "",
            state: response.data.state || ""
          }));
          if (response.message) {
            toast.success(response.message);
          }
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message;
        toast.error(errorMessage);
      } finally {
        setIsPincodeLoading(false);
      }
    }
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      setError(null);
      setSuccess(null);

      // Name validation
      if (!formData.full_name) {
        toast.error("Please enter your full name");
        return;
      }
      if (formData.full_name.length > 40) {
        toast.error("Name should not exceed 40 characters");
        return;
      }

      // Mobile number validation
      if (!formData.phone_mobile) {
        toast.error("Please enter mobile number");
        return;
      }
      if (!/^\d{10}$/.test(formData.phone_mobile)) {
        toast.error("Mobile number must be exactly 10 digits");
        return;
      }

      // Work phone validation (optional)
      if (formData.phone_work && !/^\d{10}$/.test(formData.phone_work)) {
        toast.error("Work phone must be exactly 10 digits");
        return;
      }

      // Email validation
      if (!formData.email) {
        toast.error("Please enter email address");
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        toast.error("Please enter a valid email address");
        return;
      }

      // Other required fields
      if (!formData.pin_code  || !formData.address_line_1 ||
        !formData.city || !formData.state || !formData.save_as) {
        toast.error("Please fill all required fields");
        return;
      }

      const response = await updateAddress(addressId, formData);

      if (response.status) {
        toast.success("Address updated successfully!");
        setIsEditing(false);

        const refreshResponse = await getAddressList();
        if (refreshResponse.status && refreshResponse.data) {
          setFormData(refreshResponse.data);
        }
      } else {
        toast.error(response.message || "Failed to update address");
      }
    } catch (error) {
      console.error("Error updating address:", error);
      toast.error(error.message || "Failed to update address");
    } finally {
      setIsLoading(false);
    }
  };

  const toggleEditMode = () => {
    setIsEditing(!isEditing);
  };

  return (
    <div className="verification-container">
      <SidebarTab />
      <div className="form-container">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="account-details-header">
          <h2 className="form-title">Add Address </h2>
          <div className="header-buttons">
            {!isEditing ? (
              <button className="edit-button-business" onClick={handleEditClick}>
                Edit Details
              </button>
            ) : (
              <>
                <button className="edit-button-business" onClick={() => setIsEditing(false)}>
                  Cancel
                </button>
                <button
                  className="save-button-business"
                  onClick={handleSave}
                  disabled={!isEditing || !hasFormChanges()}
                >
                  Save Details
                </button>
              </>
            )}
          </div>
        </div>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <div className="input-group">
          <div className="input-field-container">
            <label htmlFor="full_name">Full Name(Contact Person for this address)*</label>
            <input
              type="text"
              id="full_name"
              className="input-field"
              value={formData.full_name}
              onChange={handleChange}
              disabled={!isEditing}
              maxLength={40}
            />
          </div>
          <div className="input-field-container">
            <label htmlFor="email">Email Address*</label>
            <input
              type="email"
              id="email"
              className="input-field"
              value={formData.email}
              onChange={handleChange}
              disabled={!isEditing}
            />
          </div>
        </div>

        <div className="input-group">
          <div className="input-field-container">
            <label htmlFor="phone_mobile">Phone (Mobile)*</label>
            <div className="input-with-icon">
              <CiMobile3 className="phone-icon" />
              <input
                type="tel"
                id="phone_mobile"
                className="input-field"
                value={formData.phone_mobile}
                onChange={handleChange}
                disabled={!isEditing}
                maxLength={10}
                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                inputMode="numeric"
              />
            </div>
          </div>
          <div className="input-field-container">
            <label htmlFor="phone_work">Phone (Work)</label>
            <div className="input-with-icon">
              <MdLocalPhone className="phone-icon" />
              <input
                type="tel"
                id="phone_work"
                className="input-field"
                value={formData.phone_work}
                onChange={handleChange}
                disabled={!isEditing}
                maxLength={10}
                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                inputMode="numeric"
              />
            </div>
          </div>

        </div>

        <div className="input-group">
          <div className="input-field-container">
            <label htmlFor="pin_code">Pin Code*</label>
            <input
              type="text"
              id="pin_code"
              className="input-field"
              value={formData.pin_code}
              onChange={handlePincodeChange}
              maxLength={6}
              disabled={!isEditing}
              onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
              inputMode="numeric"
            />
            {isPincodeLoading && <span className="loading-text"></span>}
          </div>
          <div className="input-field-container">
            <label htmlFor="country">Country*</label>
            <input
              type="text"
              id="country"
              className="input-field"
              value="INDIA"
              onChange={handleChange}
              readOnly
              
            />
          </div>
        </div>

        <div className="input-field-container">
          <label htmlFor="address_line_1">Address Line 1*</label>
          <input
            type="text"
            id="address_line_1"
            className="input-field full-width"
            value={formData.address_line_1}
            onChange={handleChange}
            disabled={!isEditing}
          />
        </div>

        <div className="input-field-container">
          <label htmlFor="address_line_2">Address Line 2</label>
          <input
            type="text"
            id="address_line_2"
            className="input-field full-width"
            value={formData.address_line_2}
            onChange={handleChange}
            disabled={!isEditing}
          />
        </div>

        <div className="input-group">
          <div className="input-field-container">
            <label htmlFor="city">City*</label>
            <input
              type="text"
              id="city"
              className="input-field"
              value={formData.city}
              onChange={handleChange}
              readOnly
            />
          </div>
          <div className="input-field-container">
            <label htmlFor="state">State*</label>
            <input
              type="text"
              id="state"
              className="input-field"
              value={formData.state}
              onChange={handleChange}
              readOnly
            />
          </div>
        </div>

        <div className="input-field-container">
          <label htmlFor="save_as">Save as*</label>
          <input
            type="text"
            id="save_as"
            className="input-field full-width"
            value={formData.save_as}
            onChange={handleChange}
            disabled={!isEditing}
          />
        </div>

        <div className="save-address">
          <button className="saveBtnBsn" onClick={handleSave}
            disabled={!isEditing || !hasFormChanges()}
          >
            SAVE DETAILS
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyAddress;